
import firebaseApp from '../firebase/init'
import Component, { mixins } from 'vue-class-component'
import mixin from '../mixin'
import { db } from '@/main'
let app

@Component
export default class Login extends mixins(mixin) {
  btnDisable = false
  email = ''
  password = ''
  mounted() {
    app = this
    console.log('Mounted')
    console.log(this.$route)
    console.log(window.location.href)
    app.loadFields()
  }

  login() {
    this.btnDisable = true
    this.showNotification(
      'loading',
      'Cargando',
      'Estamos verificando tu identidad',
      0
    )
    firebaseApp
      .auth()
      .signInWithEmailAndPassword(this.email, this.password)
      .then(async function(user) {
        await db
          .collection('admins')
          .doc(user?.user?.uid)
          .get()
          .then(async function(doc) {
            if (doc.exists) {
              this.showNotification(
                'info',
                'Aviso',
                'Para ingresar como colaborador debes descargar la aplicación',
                10000
              )
            } else {
              await db
                .collection('client_employees')
                .doc(user?.user?.uid)
                .get()
                .then(function(doc) {
                  if (doc.exists) {
                    this.showNotification(
                      'info',
                      'Aviso',
                      'Para ingresar como cliente debe ser con alguno de tus usuarios creados',
                      10000
                    )
                  } else {
                    this.showNotification(
                      'loading',
                      'Información correcta. Iniciando sesión...',
                      0
                    )
                  }
                })
            }
          })
      })
      .catch(error => {
        // Handle Errors here.
        const errorCode = error.code
        const errorMessage = error.message

        console.log(errorCode)
        console.log(errorMessage)
        // ...
        if (errorCode === 'auth/user-not-found') {
          this.btnDisable = false
          this.showNotification('fail', 'Error', 'El usuario no existe', 2000)
        } else if (errorCode === 'auth/invalid-email') {
          this.btnDisable = false
          this.showNotification(
            'fail',
            'Error',
            'El correo electrónico no es válido.',
            2000
          )
        } else if (errorCode === 'auth/wrong-password') {
          this.btnDisable = false
          this.showNotification(
            'fail',
            'Error',
            'La contraseña no es válida.',
            2000
          )
        } else {
          this.btnDisable = false
          this.showNotification(
            'fail',
            'Error',
            'Ocurrió un error. Intenta nuevamente.',
            2000
          )
        }
      })
  }
}
